module.exports = __webpack_public_path__ + "44bf0f7a3e04ba008eb79259db8ac638.jpg";